(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.factory('securityEventsConverters', ["securityEventTypes", "securityEventStates", "linkedText", "$filter", "routeHelper", "modulesManager", "severityTypes", "troubleshooting", "feature", "apAvananExceptionsParams", "path", "beautifyKey", "escapeHtml", "genViewReportLinkInWorkflow", "sideMenuManager", "secToolsExceptionParams", function (securityEventTypes, securityEventStates, linkedText, $filter, routeHelper, modulesManager, severityTypes, troubleshooting, feature, apAvananExceptionsParams, path, beautifyKey, escapeHtml, genViewReportLinkInWorkflow, sideMenuManager, secToolsExceptionParams) {
        function getSrcArray(obj, path) {
            if (!obj || !path) {
                return;
            }
            var foundObj = obj;
            var pathArr = path.split('.');
            _(pathArr).find(function (el) {
                foundObj = foundObj[el];
                return !foundObj;
            });
            if (!foundObj) {
                return;
            }
            if (!_(foundObj).isArray()) {
                foundObj = [foundObj];
            }
            return foundObj;
        }
        function isEmptyValue(value) {
            return !value && value !== false && value !== 0;
        }
        function isEmpty(val) {
            if (_(val).isArray()) {
                return !_(val).find(function (el) {
                    return !isEmptyValue(el);
                });
            }
            return isEmptyValue(val);
        }
        function filterEmptyValues(arr) {
            return _(arr).filter(function (el) {
                return !isEmptyValue(el);
            });
        }
        function formatTooltipValue(values, type) {
            values = filterEmptyValues(_(values).isArray() ? values : [values]);
            return _(values).chain().map(function (src) {
                if (_(src).isBoolean()) {
                    return src ? 'Yes' : 'No';
                }
                if (type === 'bytes') {
                    return $filter('bytes')(src, 1, true);
                }
                if (_(src).isString() && /^\d{4}-\d{2}-\d{2}T[\d\.:\+\-]+$/.test(src)) {
                    return moment.utc(src).local().format('YYYY-MM-DD HH:mm:ss');
                }
                return escapeHtml(src);
            }).map(function (val) {
                return '<div class="value-wrapper security-events-tip-value">' + val + '</div>';
            }).value().join('');
        }
        function expandMetaData(keys, data, field, memo) {
            if (!keys.length) {
                return;
            }
            if (!data || isEmpty(data[keys[0]])) {
                return;
            }
            if (keys.length === 1) {
                var el = _(field).omit('metakey', 'metakey_show');
                el.value = data[keys[0]];
                if (field.metakey_show) {
                    el.key = beautifyKey(keys[0]);
                }
                memo.push(el);
                return;
            }
            var rest = _(keys).rest();
            if (_(data[keys[0]]).isArray()) {
                _(data[keys[0]]).each(function (el) {
                    expandMetaData(rest, el, field, memo);
                });
            } else {
                expandMetaData(rest, data[keys[0]], field, memo);
            }
        }
        function tooltipDisplayOptions(tooltip) {
            return {
                content: { text: tooltip },
                position: {
                    my: 'top left',
                    at: 'bottom left',
                    viewport: true,
                    adjust: { method: 'shift flip' }
                },
                hide: {
                    delay: 200,
                    fixed: true
                },
                style: {
                    classes: 'security-events-entity-tooltip',
                    tip: { corner: false }
                }
            };
        }
        function generateTooltip(tooltip_fields, metadata) {
            var tooltip;
            var tooltipData = _(tooltip_fields).reduce(function (memo, field) {
                if (field.type === 'entity') {
                    if (!field.entity_id || !field.entity_type || !field.label) {
                        return memo;
                    }
                    memo.push(field);
                } else {
                    if (field.metakey && field.metakey.split) {
                        if (!field.metakey.split) {
                            return memo;
                        }
                        expandMetaData(field.metakey.split('.'), metadata, field, memo);
                    } else {
                        if (!isEmpty(field.value)) {
                            memo.push(field);
                        }
                    }
                }
                return memo;
            }, []);
            if (tooltipData.length) {
                var keyExists = !!_(tooltipData).find(function (el) {
                    return el.key;
                });
                if (keyExists) {
                    _(tooltipData).each(function (el) {
                        el.key = el.key || '&nbsp;';
                    });
                }
                if (tooltipData.length === 1 && tooltipData[0].type !== 'entity' && _(tooltipData[0].value).isArray()) {
                    tooltip = '<div class="single-item-tip">';
                    if (keyExists) {
                        tooltip += '<div class="single-key">' + tooltipData[0].key + '</div>';
                    }
                    tooltip += '<div class="single-value">' + formatTooltipValue(tooltipData[0].value) + '</div>';
                } else {
                    tooltip = '<table>' + tooltipData.map(function (field) {
                        var value;
                        if (field.type === 'entity') {
                            value = '<div class="value-wrapper"><a href="' + routeHelper.getHref('profile', {
                                entityType: field.entity_type,
                                id: field.entity_id
                            }) + '">' + field.label + '</a></div>';
                        } else {
                            value = formatTooltipValue(field.value, field.type);
                        }
                        return '<tr>' + (keyExists ? '<td class="key">' + field.key + '</td>' : '') + '<td class="value">' + value + '</td></tr>';
                    }).join('') + '</table>';
                }
            }
            if (!tooltip) {
                return;
            }
            return tooltipDisplayOptions(tooltip);
        }
        function isMissingConfig(moduleConfigs, entityType, actionId) {
            try {
                if (moduleConfigs && moduleConfigs[entityType] && actionId && actionId.indexOf('quarantine') !== -1) {
                    var driveEntities = [
                        'box_file',
                        'office365_onedrive_file',
                        'office365_sharepoint_file'
                    ];
                    if (entityType === 'dropbox_file') {
                        if (moduleConfigs[entityType].quarantine_user_id && !moduleConfigs[entityType].quarantine_user_id.value) {
                            return {
                                value: true,
                                label: 'Quarantine User'
                            };
                        }
                    } else if (entityType === 'google_file') {
                        if (moduleConfigs[entityType].quarantine_target_email_address && !moduleConfigs[entityType].quarantine_target_email_address.value || moduleConfigs[entityType].quarantine_target_folder && !moduleConfigs[entityType].quarantine_target_folder.value) {
                            return {
                                value: true,
                                label: 'Quarantine Email and Quarantine Folder'
                            };
                        }
                    } else if (_(driveEntities).findIndex(function (type) {
                            return type === entityType;
                        }) !== -1) {
                        if (moduleConfigs[entityType].quarantine_target_folder && !moduleConfigs[entityType].quarantine_target_folder.value && moduleConfigs[entityType].quarantine_folder_mode && moduleConfigs[entityType].quarantine_folder_mode.value != 'default') {
                            return {
                                value: true,
                                label: 'Quarantine Folder'
                            };
                        }
                    }
                }
            } catch (err) {
                console.log('Error on isMissingConfig.', err);
            }
            return false;
        }
        var eventsConverters = {
            securityEventTypeConverter: function (text) {
                return securityEventTypes.get(text).label;
            },
            doubleLineDate: function (text) {
                var time = moment.utc(text).local();
                return '#' + JSON.stringify({
                    'display': 'text',
                    'class': 'dbl-line-date-time',
                    'text': time.format('HH:mm:ss')
                }) + '#' + JSON.stringify({
                    'display': 'text',
                    'class': 'dbl-line-date-date',
                    'text': time.format('YYYY-MM-DD')
                });
            },
            severityConverter: function (text, columnId, columnsMap, args) {
                var attributes = _(args.attributes).chain().map(function (attribute, name) {
                    return [
                        name,
                        columnsMap[attribute]
                    ];
                }).object().value();
                var editable = !!args.eventName;
                return '#' + JSON.stringify({
                    'display': 'linked-text',
                    'class': 'security-events-severity level-' + text + (editable ? ' editable' : ''),
                    'text': _(_.range(1, 6)).chain().reverse().map(function (idx) {
                        var mark = {
                            'display': 'linked-text',
                            'class': 'severity-mark severity-mark-' + idx,
                            text: '#' + JSON.stringify({
                                display: 'text',
                                'class': 'item-indicator'
                            })
                        };
                        if (editable) {
                            mark.clickEvent = {
                                name: args.eventName,
                                attributes: attributes,
                                newValue: idx,
                                oldValue: text
                            };
                            mark.tooltip = idx !== text ? 'Change to ' + severityTypes.get(idx).label : null;
                        }
                        return '#' + JSON.stringify(mark);
                    }).value().join('')
                });
            },
            stateConverter: function (text) {
                if (!text) {
                    return '';
                }
                return '#' + JSON.stringify({
                    'display': 'text',
                    'class': 'event-state state-' + text,
                    'text': securityEventStates.get(text).label
                });
            },
            getAvailableActions: function (actions, secTool, saas) {
                return _(actions).pick(function (action, actionId) {
                    if (actionId === 'quarantine_email') {
                        action.label = 'Quarantine email';
                    } else if (actionId === 'quarantine_file') {
                        action.label = 'Quarantine file';
                    } else if (actionId === 'restore_email') {
                        action.label = 'Release email';
                    } else if (actionId === 'restore_file') {
                        action.label = 'Release file';
                    }
                    if (saas === 'ms_teams' && actionId.indexOf('restore') !== -1) {
                        return false;
                    }
                    return (troubleshooting.entityDebugEnabled() || !action.debug_only) && (secTool !== 'avanan_ap_scan' || actionId !== 'report_not_ap' && actionId !== 'report_not_ap_undo');
                });
            },
            eventWorkflowConverter: function (text, columnId, event, args) {
                if (!event._resolved) {
                    return;
                }
                var download = '';
                if (event._resolved && event._resolved.download_status === 'allowed' && _([
                        'office365_emails_email',
                        'google_mail_email'
                    ]).contains(event.entity_type)) {
                    download = '#' + JSON.stringify({
                        display: 'linked-text',
                        'class': 'display-block white-space-nowrap action-link',
                        text: 'Download',
                        clickEvent: {
                            name: 'download-entity',
                            entityId: event.entity_id,
                            entityType: event.entity_type
                        }
                    });
                }
                var available_actions = eventsConverters.getAvailableActions(event._resolved.available_actions, event.matched_security_tool, event.saas);
                var available = _(available_actions).chain().map(function (action, actionId) {
                    var isMissingCf = isMissingConfig(args.moduleConfigs, event.entity_type, actionId);
                    if (isMissingCf) {
                        if (action.config_missing && action.config_missing.length) {
                            action.config_missing.push(actionId);
                        } else {
                            action.config_missing = [actionId];
                        }
                        action.config_module = event.saas;
                        action.config_error_message = 'Current configuration doesn\'t allow to perform this action.<br /><strong>' + isMissingCf.label + '</strong> should not be empty<br />';
                    }
                    action.actionId = actionId;
                    return action;
                }).compact().sortBy('order').map(function (action) {
                    var actionId = action.actionId;
                    return '#' + JSON.stringify({
                        display: 'text',
                        'class': 'display-block white-space-nowrap action-link',
                        text: action.label,
                        clickEvent: {
                            name: 'event-action',
                            eventId: event.sec_event_id,
                            actionId: actionId,
                            action: action,
                            eventData: {
                                aggregation_id: event.aggregation_id,
                                child_events: event.child_events,
                                availableIds: []
                            }
                        }
                    });
                }).value().join('');
                var exceptions = '';
                if (feature.showWhitelist && event.matched_security_tool !== 'avanan_ap_scan' && event._resolved.exceptions && event._resolved.exceptions.length) {
                    var exceptionLinks = _(event._resolved.exceptions).chain().map(function (exception) {
                        var eventParams = {
                            name: 'add-security-event-exception',
                            eventId: event.sec_event_id,
                            exceptionType: exception.exception_type,
                            exceptionLabel: exception.label,
                            eventData: event
                        };
                        var exceptionParams;
                        if (exception.params) {
                            exceptionParams = [];
                            var wrong = _(exception.params).find(function (info, param) {
                                if (!info.src) {
                                    return true;
                                }
                                var dataArr = getSrcArray(event, info.src);
                                if (!dataArr || !dataArr.length) {
                                    return true;
                                }
                                exceptionParams.push({
                                    param: param,
                                    data: dataArr,
                                    label: info.label || exception.label
                                });
                            });
                            if (wrong) {
                                return;
                            }
                            eventParams.params = exceptionParams;
                        }
                        return '#' + JSON.stringify({
                            display: 'text',
                            'class': 'display-block event-exception-link',
                            text: 'Allow-List ' + exception.label,
                            clickEvent: eventParams
                        });
                    }).compact().value();
                    exceptions = '#' + JSON.stringify({
                        display: 'inline-list',
                        'class': 'security-event-exceptions-container',
                        countText: 'Allow-List',
                        appendTo: '.table-row',
                        dropdownMenuClass: { 'event-exception-dropdown-menu': true },
                        data: exceptionLinks
                    });
                }
                if (event.matched_security_tool === 'avanan_ap_scan') {
                    exceptions = '#' + JSON.stringify({
                        display: 'text',
                        'class': 'display-block white-space-nowrap action-link',
                        text: 'Create Allow-List rule',
                        clickEvent: {
                            name: 'add-avanan-ap-exception',
                            entityId: event.entity_id,
                            entityType: event.entity_type,
                            eventId: event.sec_event_id,
                            eventData: event
                        }
                    });
                }
                if (feature.showAnomalyExceptions && event.type === 'anomaly' && event.event_metadata && event.event_metadata.metadata_json && event.event_metadata.metadata_json.columns && _(event.event_metadata.metadata_json.columns).isArray() && event.event_metadata.metadata_json.columns.length) {
                    exceptions += '#' + JSON.stringify({
                        display: 'text',
                        'class': 'display-block white-space-nowrap action-link',
                        text: 'Add Exception',
                        clickEvent: {
                            name: 'add-anomaly-exception',
                            eventId: event.sec_event_id,
                            eventData: event
                        }
                    });
                }
                // this is a blacklist of entity types that will not show "report as not fishing" button
                var denyReportAsNotPhishingTypeList = [
                    'office365_emails_email',
                    'google_mail_email'
                ];
                if (!denyReportAsNotPhishingTypeList.includes(event.entity_type) && (troubleshooting.entityDebugEnabled() || sideMenuManager.currentUser().admin) && (event.type === 'malware' || event.type === 'dlp') && event.matched_security_tool !== 'cp_threat_extraction') {
                    var secType = event.type === 'malware' ? 'av' : 'dlp';
                    var secTypeAddTitle = secToolsExceptionParams.getAddTitle(secType, event.entity_type);
                    if (secTypeAddTitle) {
                        exceptions += '#' + JSON.stringify({
                            display: 'text',
                            'class': 'display-block white-space-nowrap action-link',
                            text: secTypeAddTitle,
                            clickEvent: {
                                name: 'add-sec-tool-exception',
                                entityType: event.entity_type,
                                entityId: event.entity_id,
                                secType: secType
                            }
                        });
                    }
                }
                var reportLinks = '';
                if (event.matched_security_tool === 'checkpoint_te') {
                    genViewReportLinkInWorkflow.reportLinkForCheckpointTe(event);
                } else if (event.matched_security_tool === 'av_sonicwall') {
                    genViewReportLinkInWorkflow.reportLinkForAvSonicwall(event);
                }
                if (event.matched_security_tool === 'checkpoint_te' || event.matched_security_tool === 'av_sonicwall') {
                    var loadedData = genViewReportLinkInWorkflow.getReportLinks();
                    reportLinks = loadedData[event.entity_id] && loadedData[event.entity_id].link ? loadedData[event.entity_id].link : '';
                }
                return download + available + exceptions + reportLinks;
            },
            historyArrayConverter: function (text, columnId, columnsMap, args) {
                var arr = troubleshooting.entityDebugEnabled() ? text : _(text).filter(function (action) {
                    return !action.debug_only;
                });
                arr = _(arr).sortBy(args.field);
                if (args.reverse) {
                    return _(arr).reverse();
                }
                return arr;
            },
            historyItemConverter: function (text, columnId, columnsMap) {
                var historyTxt = '#' + JSON.stringify({
                    display: 'text',
                    'class': 'event-history-item',
                    text: columnsMap.label,
                    tooltip: $filter('localTime')(columnsMap.create_time)
                });
                if (columnsMap.error) {
                    historyTxt += '#' + JSON.stringify({
                        display: 'text',
                        'class': 'fa fa-exclamation-circle fail-20 performed-action-error',
                        tooltip: columnsMap.tooltip
                    });
                }
                return historyTxt;
            },
            descriptionConverter: function (text, columnId, columnsMap, args) {
                if (columnsMap._resolved && columnsMap._resolved[columnId]) {
                    text = columnsMap._resolved[columnId];
                }
                var parts = linkedText.toSimpleParts(text);
                return _(parts).chain().map(function (part) {
                    var visual;
                    var noTooltip = false;
                    var saasDisabledTooltip = '';
                    if (part.label === 'Sonicwall') {
                        part.label = 'SonicWall';
                    }
                    if (part.display === 'text') {
                        visual = angular.copy(part);
                    }
                    if (part.display === 'date') {
                        visual = {
                            display: 'text',
                            text: $filter('localTimeIfIsoString')(part.date)
                        };
                    }
                    if (part.display === 'embedded-entity') {
                        var entityInfo = args.objectTypes.data.entities[part.entity_type];
                        if (!entityInfo) {
                            noTooltip = true;
                            var saasInfo = modulesManager.app(columnsMap.saas);
                            if (saasInfo && saasInfo.state === 'nonactive') {
                                saasDisabledTooltip = modulesManager.app(columnsMap.saas).label + ' is disabled right now, please enable for drill-down';
                            }
                        } else if (entityInfo.security_events_hide_tooltip) {
                            noTooltip = true;
                        }
                        if (!args.disableLinks && entityInfo && !entityInfo.security_events_disable_link) {
                            visual = {
                                display: 'link',
                                'class': 'tooltip-keyword',
                                type: 'profile',
                                entityType: part.entity_type,
                                id: part.entity_id,
                                text: part.label
                            };
                        } else {
                            visual = {
                                display: 'text',
                                'class': 'tooltip-keyword-no-link',
                                text: part.label
                            };
                        }
                    }
                    if (!part.display && part.label) {
                        visual = {
                            display: 'text',
                            text: part.label
                        };
                    }
                    if (!visual) {
                        visual = {
                            display: 'text',
                            text: ''
                        };
                    }
                    if (!visual.text && visual.label) {
                        visual.text = visual.label;
                    }
                    if (!noTooltip && part.tooltip_fields) {
                        var tooltip = generateTooltip(part.tooltip_fields, columnsMap.event_metadata);
                        if (tooltip) {
                            visual.tooltip = tooltip;
                            if (!visual['class']) {
                                visual['class'] = 'tooltip-keyword-no-link';
                            }
                        }
                    } else {
                        if (saasDisabledTooltip) {
                            visual.tooltip = tooltipDisplayOptions(saasDisabledTooltip);
                        }
                    }
                    return visual;
                }).map(function (part) {
                    return '#' + JSON.stringify(part);
                }).value().join('');
            },
            eventSaas: function (text) {
                if (_(text).isNull()) {
                    return '';
                }
                var app = modulesManager.app(text);
                return '#' + JSON.stringify({
                    display: 'saas-icon',
                    text: app && app.label || 'Generic',
                    saas: app,
                    path: path('gui-v2').img('icons-round/' + (app && app.stack_icon_round || 'generic.svg'))
                });
            }
        };
        return eventsConverters;
    }]);
}());